// import React, { useState, useEffect } from "react";
// import {Button, Card} from 'react-bootstrap';
// import { loadStripe } from "@stripe/stripe-js";
// import { Elements } from "@stripe/react-stripe-js";
// import CheckoutForm from "../checkoutForm";
// import { idbPromise } from "../utils/helpers";
// import CartItem from "../cartItem";
// // import Auth from "../utils/auth";
// // import react-redux
// import { useDispatch, useSelector } from "react-redux";
// import { TOGGLE_CART, ADD_MULTIPLE_TO_CART } from "../utils/actions";
// const stripePromise = loadStripe(process.env.REACT_APP_CLIENT_KEY);

// const Cart = () => {
//   // create dispatch from useDispatch()
//   const dispatch = useDispatch();
//   // create state from useSelector()
//   const state = useSelector((s) => s);

//   // UseEffect to load cart items from IndexedDB
//   useEffect(() => {
//     async function getCart() {
//       const cartItems = await idbPromise("cart", "get");
//       console.log('iDB cart:', cartItems);
//       dispatch({ type: ADD_MULTIPLE_TO_CART, products: [...cartItems] });
//     }
  
//     if (!state.cart.length) {
//       console.log('Fetching cart from IDB');
//       getCart();
//     }
//   }, [state.cart.length, dispatch]);

//     const [clientSecret, setClientSecret] = useState("");
  
//     useEffect(() => {
//   if (!state.cart.length) return; // only run if cart has items

//   fetch("http://localhost:3001/stripePayment", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({
//       items: state.cart.map(item => ({
//         id: item._id,                 // or your item identifier
//         name: item.name,              // product name
//         quantity: item.purchaseQuantity,
//         price: item.price             // price in dollars (or cents depending on your backend)
//       }))
//     }),
//   })
//     .then((res) => {
//       if (!res.ok) {
//         throw new Error("Network response was not ok");
//       }
//       return res.json();
//     })
//     .then((data) => setClientSecret(data.clientSecret))
//     .catch((error) => {
//       console.log(error);
//     });
// }, [state.cart]);

  
//     const options = {
//       clientSecret,
//     };
  

//   function calculateTotal() {
//     let sum = 0;
//     state.cart.forEach((item) => {
//       sum += item.price * item.purchaseQuantity;
//     });
//     return sum.toFixed(2);
//   }

//   function submitCheckout() {
//   }

//   console.log('Cart Items:', state.cart);

//   return (
//    <div className="container"
//   // style={{
//   //   height: '100vh', 
//   //   width: '100vw',
//   // }}
// >
//   <h1
//     className="title-font justify-content-center"
//     style={{
//       marginTop: '4%',
//       marginBottom: '1%',
//     }}
//   >
//     shopping cart
//   </h1>

//   {state.cart.length ? (
//     <div
//       style={{
//         display: "flex",
//         alignItems: "flex-start",
//         gap: "2rem",
//         color: "white",
//         margin: "2%",
//       }}
//     >
//       {/* LEFT SIDE: Cart items + total */}
//       <div style={{ flex: 3 }}>
//         <h2>Items</h2>
//         {state.cart.map((item) => (
//           <CartItem key={item.listing} item={item} />
//         ))}

//         <h3 style={{ marginTop: "2%" }}>
//           Total: ${calculateTotal()}
//         </h3>
//       </div>

//       {/* RIGHT SIDE: Checkout card */}
//       <div style={{ flex: 2 }}>
//         <h2> Payment</h2>
//         <Card
//           style={{
//             width: "100%",
//             marginTop: "2%",
//             marginBottom: "1%",
//             color: "white",
//           }}
//         >
//           {clientSecret && (
//             <Elements options={options} stripe={stripePromise}>
//               <CheckoutForm />
//             </Elements>
//           )}
//         </Card>
//       </div>
//     </div>
//   ) : (
//     <>
//       <div
//         className="container flex-row space-between"
//         style={{
//           marginTop: "30%",
//         }}
//       >
//         <Card>
//           <h1 className=" title-font justify-content-center">Cart Empty</h1>
//         </Card>
//       </div>
//     </>
//   )}
// </div>

//   );
// };

// export default Cart;


import React, { useState, useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import { idbPromise } from "../utils/helpers";
import CartItem from "../cartItem";
import { useDispatch, useSelector } from "react-redux";
import { ADD_MULTIPLE_TO_CART } from "../utils/actions";

const Cart = () => {
  const dispatch = useDispatch();
  const state = useSelector((s) => s);

  // Load cart items from IndexedDB if not in state
  useEffect(() => {
    async function getCart() {
      const cartItems = await idbPromise("cart", "get");
      dispatch({ type: ADD_MULTIPLE_TO_CART, products: [...cartItems] });
    }

    if (!state.cart.length) {
      getCart();
    }
  }, [state.cart.length, dispatch]);

  // Calculate total for display only
  function calculateTotal() {
    let sum = 0;
    state.cart.forEach((item) => {
      sum += item.price * item.purchaseQuantity;
    });
    return sum.toFixed(2);
  }

  // Create checkout session and redirect
  async function handleCheckout() {
    try {
      const res = await fetch("https://second-team-productions.onrender.com/stripeCheckout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: state.cart.map((item) => ({
            name: item.name,
            details: item.details,
            price: item.price,
            purchaseQuantity: item.purchaseQuantity,
          }))
          ,
          cancelUrl: window.location.href 
        }),
      });

      const data = await res.json();

      if (data.url) {
        window.location.href = data.url; // Redirect to Stripe Checkout
      } else {
        console.error("No URL returned from Stripe Checkout session.");
      }
    } catch (err) {
      console.error("Error creating checkout session:", err);
    }
  }

  return (
    <div>
      {state.cart.length ? (
        <div>
          <div>
            {state.cart.map((item) => (
              <CartItem key={item.listing} item={item} />
            ))}
            <h5 style={{ marginTop: "5%", marginLeft: '5%', }}>
              Total: ${calculateTotal()}
            </h5>
          </div>
          <div>
            <Card>
              <Button
                className="process-card-text hover-brighten"
                 style={{
                display: 'block',
                height: 'auto',
                width: 'auto',
                margin: '5px auto',
                fontSize: '2.5vmin',
                backgroundColor: 'rgb(0, 128, 0)',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                textAlign: 'center',
              }}
                onClick={handleCheckout}
              >
                <h5 style={{ margin: "1%" }}>checkout</h5>
              </Button>
            </Card>
          </div>
        </div>
      ) : (
        <>
          <div
            className="container flex-row space-between"
            style={{ marginTop: "30%" }}
          >
            <Card>
              <h1 className=" title-font justify-content-center">Cart Empty</h1>
            </Card>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
